module.exports = __webpack_public_path__ + "static/media/cornerLogo.7c1442d5.svg";